export interface IInset {
    top: number;
    right: number;
    bottom: number;
    left: number;
}

export class Inset implements IInset {
    constructor(
        public top: number = 0,
        public right: number = 0,
        public bottom: number = 0,
        public left: number = 0) {
    }

    public toString(): string {
        return "[ Inset"
            + " top=" + this.top
            + " right=" + this.right
            + " bottom=" + this.bottom
            + " left=" + this.left
            + "]";
    }
}